import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {LoaderService} from '@/sdk';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class InspectionsAndCAWarningsListComponent extends VueWrapper {
    @Prop({
        required: true,
    })
    public siteId!: string;

    public alertsList: any[] = [];

    public mounted(): void {
        this.getAlerts();
    }

    public getAlerts() {
        new LoaderService().showFullScreenLoader('Loading data field rules status.');
        this.alertsList = [];
        new LoaderService().hideFullScreenLoader();
    }
}
